import { ZfCheckbox } from '@zafire/react';
import type { ReactNode } from 'react';

interface IClientPackageCheckboxItemProps {
    actions?: ReactNode;
    isDisabled: boolean;
    isSelected: boolean;
    label: string;
    onChange: (isChecked: boolean) => void;
}

export const ClientPackageCheckboxItem = ({ actions, isDisabled, isSelected, label, onChange }: IClientPackageCheckboxItemProps) => {
    const checkboxComponent = (
        <ZfCheckbox label={label} disabled={isDisabled} checked={isSelected} onCheckboxCheck={(event: CustomEvent<boolean>) => onChange(event.detail)} />
    );

    return actions ? (
        <div className="client-package-editor__checkbox-with-actions">
            {checkboxComponent}
            {actions}
        </div>
    ) : (
        <div className="client-package-editor__checkbox-item">{checkboxComponent}</div>
    );
};
